const activities = [
    {
        imgSrc: "https://iili.io/oTEVz7.png",
        altText: "Satyen Bose Science Club BUET",
        link: "#",
        role: "Campus Ambassador"
    },
    {
        imgSrc: "img/Activity&Award/bncc.jpg",
        altText: "BNCC—PSTU (Naval Wing)",
        link: "/",
        role: "Cadet"
    },
    {
        imgSrc: "img/Activity&Award/youthmappers.png",
        altText: "YouthMappers, PSTU Chapter",
        link: "/",
        role: "Head of Media & IT"
    },
    {
        imgSrc: "https://iili.io/oTEYfs.jpg",
        altText: "Bangladesh Flying Labs",
        link: "/",
        role: "Volunteer"
    },

    {
        imgSrc: "img/Activity&Award/pstucc.jpg",
        altText: "PSTU Career Club",
        link: "/",
        role: "Faculty Ambassador"
    },
    {
        imgSrc: "img/Activity&Award/bnec.jpg",
        altText: "BUET Nuclear Engineering Club",
        link: "/",
        role: "Associate"
    }
];

export default activities;
